<template>
    <div><ly-form-item label="币别" lw="2.5">
            <currency v-model="currency"></currency>
        </ly-form-item>
        <ly-form-item label="公式" lw="2.5">
            货值×<InputNumber size="small" style="width:60px;" v-model="num"></InputNumber>/{{ this.percent }}
        </ly-form-item>
        <ly-form-item label="基础价" lw="3.5">
            <Select size="small" v-model="type" style="width:80px;">
                <Option value="最低">最低</Option>
                <Option value="最高">最高</Option>
            </Select>
            <InputNumber size="small" style="width:60px;" v-model="number"></InputNumber>
        </ly-form-item>

    </div>
</template>
<script>
import currency from "../baojia/currency.vue";
export default {
    components: { currency },
    props: ["bbb",],
    model: {
        prop: "bbb",
        event: "aaa",
    },
    data() {
        return {
            num: 0,
            number: 0,
            percent: 10000,
            currency: '',
            type: ''
        }
    },
    methods: {
        tt() {
            eval('this.' + this.bbb);
        },
        huoZhi(a, b, c, d) {
            this.num = a * this.percent;
            this.number = b;
            this.currency = c;
            this.type = d;
        },
        emit() {
            this.$emit('aaa', "huoZhi(" +
                this.num + "/" +
                this.percent + "," +
                this.number + ",'" +
                this.currency + "','" +
                this.type +

                "')")
        }
    },
    mounted() {
        this.tt();
    },
    watch: {
        num(v) {
            this.emit();
        },
        number(v) {
            this.emit();
        },
        currency(v) {
            this.emit();
        },
        type(v) {
            this.emit();
        },
        bbb() {
            this.tt();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/gongshi/huoZhi.vue